<template>
	<div id="location-picker">
		<v-select :options="compProvinceOptions" required placeholder="Province" v-model="province"></v-select>
		<v-select :options="compAreaOptions" placeholder="Area" v-model="area"></v-select>
		<v-select :options="compSuburbOptions" placeholder="Suburb" v-model="suburb"></v-select>

		<div v-if="!prop_crud" class="hide">
			<input type="hidden" name="province_id" :value="province ? province.id : null">
			<input type="hidden" name="area_id" :value="area ? area.id : null">
			<input type="hidden" name="suburb_id" :value="suburb ? suburb.id : null">
		</div>
		<div v-else>
			<input type="text" :name="field_name ? field_name : 'location_id'" id="location_id" class="location_id" required :value="suburb ? suburb.id : area ? area.id : province ? province.id : null">
			<span class="form-error" data-form-error-for="location_id">Area is required.</span>
		</div>
	</div>
</template>

<script>
	import vSelect from "vue-select";

	export default {
		components: { vSelect },
		name: 'location-picker',
		props: {
			prop_crud: { default: false },
			prop_locations: { type: String, required: true },
			prop_province_id: { default: false },
			prop_area_id: { default: false },
			prop_suburb_id: { default: false },
			prop_field_name: { default: false }
		},
		computed: {
			compProvinceOptions() {
				return this.locations;
			},
			compAreaOptions() {
				if(!this.province) {
					this.area = null;
					return [];
				}

				return this.province.children;
			},
			compSuburbOptions() {
				if(!this.area) {
					this.suburb = null;
					return [];
				}

				return this.area.children;
			}
		},
		data() {
			return {
				locations: [],
				province: null,
				area: null,
				suburb: null,
				field_name: null
			}
		},
		mounted() {
			this.locations = JSON.parse(this.prop_locations);
			this.field_name = this.prop_field_name;

			for(let province of this.locations) {
				if (province.id == this.prop_province_id) {
					this.province = province;

					for(let area of province.children) {
						if (area.id == this.prop_area_id) {
							this.area = area;

							for(let suburb of area.children) {
								if(suburb.id == this.prop_suburb_id) {
									this.suburb = suburb;
									break;
								}
							}

							break;
						}
					}

					break;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	#location-picker {
		.dropdown {
			margin-bottom: 15px;
		}

		.location_id {
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// assets/js/vue/components/LocationPicker.vue